var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicpayLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#008fff",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.463 1.587v7.537h7.537v-7.537zm1.256 1.256h5.025v5.025h-5.025zm1.256 1.256v2.513h2.513v-2.513zm-15.205 1.256v3.175h3.376c2.142 0 3.358 1.04 3.358 2.939 0 1.947-1.216 3.011-3.358 3.011h-3.377v-5.95h-3.769v13.884h3.769v-4.76h3.57c4.333 0 6.815-2.352 6.815-6.32 0-3.771-2.482-5.978-6.814-5.978z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicpayLogo);
export default __webpack_public_path__ + "static/media/picpay-logo.e701c21c0e86ad46b23be9849e16c911.svg";
export { ForwardRef as ReactComponent };